module.exports = __webpack_public_path__ + "img/20201006_120113.338d28c7.jpg";